module.exports = __webpack_public_path__ + "static/media/4-Load-Regulation-2.4e1d6288.svg";